module.exports = __webpack_public_path__ + "img/double-arrow.9e601013.svg";